import { lazy } from "react";

export { SIGNING_DOCUMENTS_PATH } from "./signing-documents-path";
export const SigningDocumentsPage = lazy(
  () => import("./signing-documents-page"),
);
